import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BookOpen, Search, ArrowRight } from '../../components/Icons';
import styles from './TryWithoutLogin.module.css';

function TryWithoutLogin() {
  const { i18n } = useTranslation();
  const isID = i18n.language === 'id';

  const cards = [
    {
      icon: <BookOpen size={24} strokeWidth={1.5} aria-hidden="true" />,
      tag: isID ? 'Gratis dan mudah digunakan' : 'Free and easy to use',
      title: isID ? 'Baca artikel informasi pencernaan anak' : 'Read information articles',
      desc: isID
        ? 'Pelajari tentang GI & ASD, Bristol Stool Chart, nutrisi, dan tips praktis untuk caregiver.'
        : 'Learn about GI & ASD, Bristol Stool Chart, nutrition, and practical tips for caregivers.',
      cta: isID ? 'Baca sekarang' : 'Read now',
      to: '/public-info',
    },
    {
      icon: <Search size={24} strokeWidth={1.5} aria-hidden="true" />,
      tag: isID ? 'Tanpa harus login' : 'No login required',
      title: isID ? 'Coba tes skrining' : 'Try screening test',
      desc: isID
        ? 'Lakukan skrining awal, tingkat keparahan gejala, dan tingkat rasa nyeri yang dirasakan anak. Lihat hasilnya tanpa perlu mendaftar.'
        : 'Take the initial, symptom-severity, and pain-level screenings. See the results without registering.',
      cta: isID ? 'Mulai tes' : 'Start test',
      to: '/public-screening',
    },
  ];

  return (
    <section className={styles.try}>
      <div className={styles.container}>
        <div className="eyebrow">{isID ? 'Coba Sekarang' : 'Try Now'}</div>
        <h2 className={`section-headline ${styles.headline}`}>
          {isID ? 'Jelajahi tanpa perlu daftar' : 'Explore without signing up'}
        </h2>

        <div className={styles.grid}>
          {cards.map((c, i) => (
            <div key={i} className={styles.card}>
              <span className={styles.tag}>{c.tag}</span>
              <div className={styles.iconBox}>{c.icon}</div>
              <h3 className={styles.cardTitle}>{c.title}</h3>
              <p className={styles.cardDesc}>{c.desc}</p>
              <Link to={c.to} className={styles.cardLink}>
                {c.cta}
                <ArrowRight size={16} strokeWidth={2} aria-hidden="true" />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TryWithoutLogin;